import Quill from 'quill';
import QuillResize from 'quill-resize-module';

import 'quill-resize-module/dist/resize.css';
import 'quill/dist/quill.snow.css';

Quill.register('modules/resize', QuillResize);

export default Quill;
